import ConfirmDialog from "./ConfirmDialog";
import Dialog from "./Dialog";
import InfoDialog from "./InfoDialog";
import SpaceStatusDialog from "./SpaceStatusDialog";

export default Dialog;
export { ConfirmDialog, InfoDialog, SpaceStatusDialog };
